import { getCookieValue } from 'dibs-consented-storage';
import { type Cookie } from './types';
import { getSessionIdWithDateString } from 'dibs-ga-utils';

const GA_DEVICE_ID_COOKIE_KEY = '_ga';
const GA_SESSION_COOKIE_KEY = '_ga_9JKGTT75T7';

export const getGASessionId = (cookie: Cookie): string | null => {
    const gaDeviceCookie = getCookieValue(cookie, GA_DEVICE_ID_COOKIE_KEY);
    if (!gaDeviceCookie) {
        return null;
    }
    const gaSessionCookie = getCookieValue(cookie, GA_SESSION_COOKIE_KEY);
    if (gaSessionCookie === null) {
        return null;
    }
    const { deviceId, dateString, sessionTimestamp } =
        getSessionIdWithDateString({
            gaDeviceCookie,
            gaSessionCookie,
        }) || {};

    return `${deviceId}-${dateString}-${sessionTimestamp}`;
};
